"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
var tslib_1 = require("tslib");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var storage_1 = require("@jsmodules/storage");
var pipeline_1 = require("../pipeline");
var LoginMethods = /** @class */ (function () {
    function LoginMethods() {
        this.methods = {};
    }
    LoginMethods.prototype.use = function (type, callbackFn) {
        this.methods[type] = this.methods[type] || [];
        this.methods[type].push(callbackFn);
    };
    LoginMethods.prototype.exec = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, callbacks, result, callbacks_1, callbacks_1_1, callback, e_1_1;
            var e_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        type = options.type;
                        if (!this.methods[type]) return [3 /*break*/, 9];
                        callbacks = this.methods[type];
                        result = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        callbacks_1 = tslib_1.__values(callbacks), callbacks_1_1 = callbacks_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!callbacks_1_1.done) return [3 /*break*/, 5];
                        callback = callbacks_1_1.value;
                        return [4 /*yield*/, callback(options, result)];
                    case 3:
                        result = _b.sent();
                        _b.label = 4;
                    case 4:
                        callbacks_1_1 = callbacks_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, result];
                    case 9: throw new Error("\u672A\u914D\u7F6E\u767B\u5F55\u65B9\u5F0F" + type);
                }
            });
        });
    };
    return LoginMethods;
}());
var interceptors = {
    getTokenObject: new pipeline_1.Pipeline(),
    getSecurityHeaders: new pipeline_1.Pipeline(),
    loginMethods: new LoginMethods(),
};
var TokenService = /** @class */ (function () {
    function TokenService(skey) {
        if (skey === void 0) { skey = "access_token"; }
        this.skey = skey;
    }
    Object.defineProperty(TokenService, "interceptors", {
        get: function () {
            return interceptors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenService.prototype, "tokenStore", {
        get: function () {
            return storage_1.kvManager.get("TokenService", { encrypted: true });
        },
        enumerable: false,
        configurable: true
    });
    TokenService.prototype.getTokenObject = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _b, token;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.current) return [3 /*break*/, 2];
                        _b = this;
                        return [4 /*yield*/, this.tokenStore.getAsync(this.skey)];
                    case 1:
                        _b.current = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, interceptors.getTokenObject.exec(null, this.current)];
                    case 3:
                        token = _c.sent();
                        if (!!token) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.logout()];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(((_a = this.current) === null || _a === void 0 ? void 0 : _a.key) != token.key)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.tokenStore.setAsync(this.skey, token)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        this.current = token;
                        return [2 /*return*/, this.current];
                }
            });
        });
    };
    TokenService.prototype.login = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, interceptors.loginMethods.exec(options)];
                    case 1:
                        token = _a.sent();
                        token.auto_login = options.auto_login || false;
                        token.created_unix = Math.floor(new Date().getTime() / 1000);
                        return [4 /*yield*/, this.tokenStore.setAsync(this.skey, token)];
                    case 2:
                        _a.sent();
                        this.current = token;
                        return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.logout = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenStore.removeAsync(this.skey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokenObject()];
                    case 1:
                        obj = _a.sent();
                        if (obj) {
                            return [2 /*return*/, obj.access_token];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    TokenService.prototype.getSecurityHeaders = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj, headers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokenObject()];
                    case 1:
                        obj = _a.sent();
                        return [4 /*yield*/, interceptors.getSecurityHeaders.exec(obj, null)];
                    case 2:
                        headers = _a.sent();
                        if (headers) {
                            return [2 /*return*/, headers];
                        }
                        // if (obj) {
                        //     return {
                        //         Authorization: `${obj.token_type} ${obj.access_token}`,
                        //     };
                        // }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    TokenService.diOptions = di_1.default.options({
        name: "TokenService",
        scope: "Singleton",
    });
    return TokenService;
}());
exports.TokenService = TokenService;
